import React from 'react';

import { IIconProps } from './constants';

const ICON_WIDTH_OR_HEIGHT = 15;

export const FilledWarningIcon = ({
  width = ICON_WIDTH_OR_HEIGHT,
  height = ICON_WIDTH_OR_HEIGHT,
}: IIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 1.25C4.04822 1.25 1.25 4.04822 1.25 7.5C1.25 10.9518 4.04822 13.75 7.5 13.75C10.9518 13.75 13.75 10.9518 13.75 7.5C13.75 4.04822 10.9518 1.25 7.5 1.25Z"
        fill="#CC1E15"
      />
      <path
        d="M7.5 5L7.5 7.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10L7.49375 10"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
